export const TOGGLE_VIEW = {
  INTERVENTIONS: 'INTERVENTIONS',
  LAUNCH: 'LAUNCH',
  MONITOR: 'MONITOR',
  PREPARE: 'PREPARE',
  SETUP: 'SETUP',
}
